<template>
  <pop-up
    title="Alert Details"
    button-text="Edit"
    class="top-fade-in details"
    @close="$emit('close')"
    @add="editAlert"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <loading-page
        v-if="gettingAlert"
        class="loading m-0 p-0"
      />
      <div
        v-else
        class="container"
      >
        <overview />
      </div>
    </transition>
  </pop-up>
</template>

<script>
import redirectError from '@/services/redirectError'
import Overview from './Details.vue'
import PopUp from '@/components/popup/Pop-up.vue'

export default {
  name: 'AlertDetails',
  components: { Overview, PopUp },
  props: {
    alertId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      id: null,
      hasAlertPermissions: true,
    }
  },
  computed: {
    gettingAlert() {
      return this.$store.state.alerts.gettingAlert
    },
    alert() {
      return this.$store.state.alerts.alert
    },
  },
  created() {
    this.id = this.alertId
    this.getAlert()
  },
  methods: {
    getAlert() {
      this.$store.dispatch('alerts/getAlert', this.id).catch(error => {
        if (error.response?.status === 403) {
          this.hasAlertPermissions = false
          return
        }
        redirectError(error)
        this.errorToast(
          error.response?.data?.errors[0]
            || 'Something went wrong while fetching alert!',
        )
      })
    },
    editAlert() {
      this.$emit('editAlert', this.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.loading::v-deep {
  padding: 1.5rem !important;
}
.details {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
